import { Controller } from "@hotwired/stimulus"
import { show_error, show_success, hide_messages } from "lib/helpers"

// accounts/edit — data-controller="account--edit"
export default class extends Controller {
  static targets = ["form"]

  static values = {
    emailRequired: Boolean,
  }

  connect() {
    $("#main-nav").removeClass("selected").find(".account").addClass("selected")

    this.$form = $(this.formTarget)
    this.#addCustomValidators()
    this.#setupValidation()
  }

  disconnect() {
    if (this.$form) {
      const validator = this.$form.data("validator")
      if (validator) {
        validator.resetForm()
        this.$form.removeData("validator")
      }
      this.$form.find("label.error").remove()
    }
    $("#digits").off(".accountEdit")
    this.$form = null
  }

  submit(event) {
    event.preventDefault()
    if (!this.$form.valid()) return
    this.#submitForm(this.formTarget)
  }

  preventDigitsClick(event) {
    event.preventDefault()
  }

  #addCustomValidators() {
    if ($.validator.methods.regex) return

    $.validator.addMethod(
      "regex",
      function (value, element, regexp) {
        return this.optional(element) || regexp.test(value)
      },
      "Please check your input.",
    )
  }

  #setupValidation() {
    const PHONE = /^[-0-9()+*#]+$/
    const EMAIL = /^[A-Z0-9_\.%\+\-']+@(?:[A-Z0-9\-]+\.)+(?:[A-Z]{2,50}|museum|travel|social|email)$/i
    const ALLNUM_ALLPUNCT = /^[-A-Za-z0-9\]\[\!\"\#\$\%\&\'\(\)\*\+\,\.\/\:\;\<\=\>\?\@\\\^\_\`\{\|\}\~]+$/
    const FULL_NAME = /^[^><;]{1,200}$/

    this.$form.validate({
      onsubmit: false,
      rules: {
        "user[login]": {
          required: true,
          regex: ALLNUM_ALLPUNCT,
          minlength: 1,
          maxlength: 70,
        },
        "user[full_name]": {
          required: true,
          regex: FULL_NAME,
          minlength: 1,
          maxlength: 200,
        },
        "user[website]": {
          required: false,
          minlength: 3,
          maxlength: 200,
          url: true,
        },
        "user[email]": {
          required: this.emailRequiredValue,
          regex: EMAIL,
        },
        "user[phone]": {
          regex: PHONE,
          minlength: 0,
          maxlength: 50,
        },
        "user[password]": {
          required: false,
          regex: ALLNUM_ALLPUNCT,
          minlength: 8,
          maxlength: 40,
        },
        "user[password_confirmation]": {
          equalTo: "#user_password",
        },
      },
      messages: {
        "user[email]": {
          email: "Bad format",
        },
        "user[website]": {
          regex: "Your website was in incorrect format, website address expected",
        },
        "user[phone]": {
          regex: "Bad format",
        },
      },
    })

    $("#digits").on("click.accountEdit", (e) => this.preventDigitsClick(e))
  }

  #submitForm(form) {
    this.#startLoading()
    $(form).ajaxSubmit({
      beforeSend: () => hide_messages(),
      success: (json_data) => {
        this.#finishLoading()
        if (json_data.success) {
          show_success(json_data.message)
          this.#clearPasswordFields()
        } else {
          this.#clearPasswordFields()
          show_error(json_data.message)
        }
      },
      error: (json_data) => {
        this.#finishLoading()
        show_error(json_data.responseJSON.errors)
      },
      dataType: "json",
    })
  }

  #clearPasswordFields() {
    $("#user_old_password").val("")
    $("#user_password").val("")
    $("#user_password_confirmation").val("")
  }

  #startLoading() {
    $(".disableable").attr("disabled", "disabled")
    $(".inline-loading").fadeIn()
  }

  #finishLoading() {
    $(".disableable").removeAttr("disabled")
    $(".inline-loading").hide()
  }
}
